import "./RefundPolicy.css";

const RefundPolicy = () => {
  return (
    <div className="refund-page">
      {/* Hero */}
      <div className="refund-hero">
        <div className="refund-hero-badge">Policy Document</div>
        <h1>Refund Policy</h1>
        <p>
          We are committed to delivering high-quality, impactful training. Please
          review our structured refund policy below before enrolling.
        </p>
      </div>

      {/* Body */}
      <div className="refund-body">

        {/* Section 1 */}
        <div className="refund-section">
          <div className="refund-section-title">
            <span className="refund-section-num">1</span>
            <h2>Standard Cohort Programs (Weekday / Weekend Sessions)</h2>
          </div>
          <ul>
            <li>
              <span className="refund-tag green">Full Refund (100%)</span>
              Eligible if a written request is submitted within <strong>24 hours</strong> of payment.
            </li>
            <li>
              <span className="refund-tag orange">Partial Refund (80%)</span>
              Eligible if a written request is submitted at least <strong>7 calendar days</strong> before the official cohort/class start date.
            </li>
            <li>
              <span className="refund-tag orange">Partial Refund (60%)</span>
              Requesting a refund between <strong>1 to 6 days</strong> before the cohort start date attracts a 40% administrative retention fee to cover reserved seat costs.
            </li>
            <li>
              <span className="refund-tag red">No Refund</span>
              Once class sessions begin (Day 1 of the cohort), no refunds will be issued, regardless of attendance.
            </li>
          </ul>
        </div>

        {/* Section 2 */}
        <div className="refund-section">
          <div className="refund-section-title">
            <span className="refund-section-num">2</span>
            <h2>Deferrals and Cohort Transfers</h2>
          </div>
          <ul>
            <li>
              If you are unable to attend your registered cohort due to unforeseen circumstances, you may request a <strong>one-time deferral</strong> to the next available cohort.
            </li>
            <li>
              Deferral requests must be submitted in writing at least <strong>48 hours</strong> prior to the start of the program.
            </li>
            <li>
              Once a registration is deferred, it is <strong>no longer eligible</strong> for a cash refund under any circumstances.
            </li>
          </ul>
        </div>

        {/* Section 3 */}
        <div className="refund-section">
          <div className="refund-section-title">
            <span className="refund-section-num">3</span>
            <h2>Specialised Masterclasses &amp; Micro-Courses</h2>
          </div>
          <p>
            For short-term intensives, business automation workshops, or masterclasses spanning <strong>3 days or less</strong>:
          </p>
          <ul>
            <li>
              Refund requests must be submitted at least <strong>72 hours</strong> before the masterclass commences.
            </li>
            <li>
              No refunds or transfers are permitted after this window, as digital infrastructure and course materials are provisioned immediately upon registration.
            </li>
          </ul>
        </div>

        {/* Section 4 */}
        <div className="refund-section">
          <div className="refund-section-title">
            <span className="refund-section-num">4</span>
            <h2>Program Cancellation by GritinAI Global LTD</h2>
          </div>
          <p>
            In the rare event that GritinAI cancels a training program or reschedules a cohort to a date that does not align with your schedule, enrolled students will be offered a choice between:
          </p>
          <ul>
            <li>
              <span className="refund-tag green">Option A</span>
              A <strong>100% full refund</strong> of the tuition paid.
            </li>
            <li>
              <span className="refund-tag green">Option B</span>
              An immediate <strong>transfer to an alternate upcoming cohort</strong>.
            </li>
          </ul>
        </div>

        {/* Section 5 */}
        <div className="refund-section">
          <div className="refund-section-title">
            <span className="refund-section-num">5</span>
            <h2>How to Request a Refund</h2>
          </div>
          <p>To initiate a refund request, please follow these steps:</p>
          <ol className="refund-steps">
            <li>
              Send an email to{" "}
              <span className="refund-email">program@gritinai.com</span> and cc{" "}
              <span className="refund-email">operations@gritinai.com</span>.
            </li>
            <li>
              Use the subject line:{" "}
              <strong>Refund Request: [Your Full Name] – [Program Name]</strong>.
            </li>
            <li>
              Include your <strong>proof of payment / invoice</strong> and the specific reason for your withdrawal.
            </li>
          </ol>
          <div className="refund-note">
            <strong>Processing Time:</strong> Approved refunds will be processed within <strong>3 to 7 business days</strong> via the original method of payment. Any third-party transaction processing fees charged by payment gateways may be deducted from the final refund amount.
          </div>
        </div>

      </div>
    </div>
  );
};

export default RefundPolicy;
